var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_8543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 5.83301C1.50097 8.57978 1.50097 11.418 2.08301 14.1648C2.15949 14.4437 2.30725 14.698 2.51177 14.9025C2.71629 15.107 2.97052 15.2548 3.24946 15.3313C7.71817 16.0717 12.2783 16.0717 16.747 15.3313C17.0259 15.2548 17.2801 15.107 17.4847 14.9025C17.6892 14.698 17.8369 14.4437 17.9134 14.1648C18.4955 11.418 18.4955 8.57978 17.9134 5.83301C17.8369 5.55407 17.6892 5.29984 17.4847 5.09532C17.2801 4.8908 17.0259 4.74304 16.747 4.66656C12.2783 3.92625 7.71818 3.92625 3.24946 4.66656C2.97052 4.74304 2.71629 4.8908 2.51177 5.09532C2.30725 5.29984 2.15949 5.55407 2.08301 5.83301Z",
    stroke: "#FB2C36",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 12.4971L12.4979 9.99758L8.33203 7.49805V12.4971Z",
    stroke: "#FB2C36",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_8543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9963,
    height: 19.9963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube2);
export default __webpack_public_path__ + "static/media/youtube2.3f0d8b67c8a114860ec8731c63eede25.svg";
export { ForwardRef as ReactComponent };